module.exports = __webpack_public_path__ + "static/media/decaffeine.15d92500.jpg";